var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.index == 1)?_c('step-1',{on:{"changeIndex":_vm.changeIndex}}):_vm._e(),(_vm.index == 2)?_c('step-2',{on:{"changeIndex":_vm.changeIndex}}):_vm._e(),(_vm.index == 3)?_c('step-3',{on:{"changeIndex":_vm.changeIndex}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }